export default __webpack_public_path__ + "static/media/trafficPolice.b334fa96.svg";